import React, { forwardRef } from 'react'
import { CheckmarkCircleIcon } from '@navikt/aksel-icons'
import { BodyShort, Button } from '@navikt/ds-react'
import { OrganisasjonMedState } from '../Virksomhetsvelger/useTastaturNavigasjon'
import { formatOrgNr } from '../Virksomhetsvelger/util'
import { Organisasjon } from '../Virksomhetsvelger/Virksomhetsvelger'
import styles from './Underenhet.module.css'

type UnderenhetProps = {
    onClick: (underenhet: Organisasjon) => void
    onFocus: (e: React.FocusEvent<HTMLButtonElement>) => void
    underenhet: OrganisasjonMedState
    tabbable?: boolean
}
export const Underenhet = forwardRef<HTMLButtonElement, UnderenhetProps>(({ onClick, underenhet, onFocus, tabbable = true }, ref) => (
    <Button
        type="button"
        ref={ref}
        tabIndex={tabbable ? (underenhet.valgt ? 0 : -1) : -1}
        aria-pressed={underenhet.valgt}
        variant="tertiary"
        onClick={() => onClick(underenhet)}
        onFocus={onFocus}
        className={styles.underenhetInnhold}
    >
        <div className={styles.underenhet}>
            <div className={styles.underenhetTekst}>
                <BodyShort className={styles.underenhetTittel}>{underenhet.navn}</BodyShort>
                <BodyShort>
                    <span>Org.nr. </span>
                    <span>{formatOrgNr(underenhet.orgnr)}</span>
                </BodyShort>
            </div>
            {underenhet.valgt && <CheckmarkCircleIcon aria-hidden={true} fontSize="1.5rem" className={styles.underenhetValgtIkon} />}
        </div>
    </Button>
))
